import { useContext, useEffect, useState } from "react";
import useHttp from "../../hooks/use-http";
import { ISeatsContext } from "../../types/seats";
import AuthContext from "../auth/auth-context";
import SeatsContext from "./seats-context";

const seatsReducer = () => {};

const SeatsProvider = (props: any) => {
  const [planState, setPlanState] = useState("Basic");
  const [BillingDateState, setBillingDateState] = useState("");
  const [availableSeatsState, setAvailableSeatsState] = useState(10);
  const [consumedSeatsState, setConsumedSeatsState] = useState(0);
  const [consumedPercentageState, setConsumedPercentageState] = useState(0);
  const [seatsState, setSeatsState] = useState([]);
  const [lastRenewal, setLastRenewal] = useState("");
  const [subscriptionStatusState, setSubscriptionStatusState] = useState(false);
  const authCxt = useContext(AuthContext)


  const {
    isLoading,
    isError,
    message,
    sendRequest: fetchSeats,
  } = useHttp();

  const fetchSeatsResponse = (resData: any) => {
// console.log("fetchSeatsResponse", resData)
        const data = resData.data;
        const resSeats = resData.data.seats;
        setPlanState(data.plan.plan || 10)
        setBillingDateState(data.plan.createdAt || new Date(new Date().setFullYear(new Date().getFullYear() + 1)))
        setAvailableSeatsState(data.plan.availableSeats || 10)
        setConsumedSeatsState(data.activeSeats || 0)
        setSeatsState(resSeats || [])
        setLastRenewal(data.plan.lastRenewal);
        setSubscriptionStatusState(data.plan.subscriptionStatus)

  }

  useEffect(()=>{
    fetchSeats(
        {
          URL: "/api/seats",
          method: "GET",
          header: {
            "Content-Type": "application/json",
          }
        },
        fetchSeatsResponse
      );
  },[authCxt])
  const seatContextValue: ISeatsContext = {    
    availableSeats: availableSeatsState,
    consumedSeats: consumedSeatsState,
    consumedPercentage: consumedPercentageState,
    plan: planState,
    billingDate: BillingDateState,
    seats: seatsState,
    lastRenewal: lastRenewal,
    subscriptionStatus: subscriptionStatusState
  };

  return (
    <SeatsContext.Provider value={seatContextValue}>
      {props.children}
    </SeatsContext.Provider>
  );
};

export default SeatsProvider;
